import { render, staticRenderFns } from "./UserRoute.vue?vue&type=template&id=546d178f&scoped=true&"
import script from "./UserRoute.vue?vue&type=script&lang=js&"
export * from "./UserRoute.vue?vue&type=script&lang=js&"
import style0 from "./UserRoute.vue?vue&type=style&index=0&id=546d178f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546d178f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VDataTable,VIcon})
